import { createContext } from 'react';

const ToDoContext = createContext();

export default ToDoContext;
